import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=86df7248&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86df7248",
  null
  
)

export default component.exports